export const ROOT_PATHS = {
  home: '',
  profile: 'profile',
  wallet: 'wallet',
  services: 'services',
  invoice_history: 'invoice-history',
  support: 'support',
  login: 'login',
  register: 'register',
  confirm: 'confirm',
  mfa: 'mfa',
  reset: 'reset',
  newPassword: 'new-password',
  forceChange: 'force-change-password',
  notFound: '404',
  another: '**',
};
